define(function (require) {
    'use strict';

    return {
        popups: {},
        activate_tariff         : () => import('modals/activate_tariff/view'),
        activate_package        : () => import('modals/activate_package/view'),
        constructor_help_text   : () => import('modals/constructor_help_text/view'),
        atc_setting             : () => import('modals/atc_setting/view'),
        add_funds               : () => import('modals/add_funds/view'),
        create_ticket           : () => import('modals/create_ticket/view'),
        code_send_manual        : () => import('modals/code_send_manual/view'),
        confirm_delete          : () => import('modals/confirm_delete/view'),
        confirm_wait_time       : () => import('modals/confirm_wait_time/view'),
        tickets_check_codes     : () => import('modals/tickets_check_codes/view'),
        tickets_add_db          : () => import('modals/tickets_add_db/view'),
        tickets_help_answer     : () => import('modals/tickets_help_answer/view'),
        tickets_write_director  : () => import('modals/tickets_write_director/view'),
        crater_add_outlay       : () => import("modals/crater_add_outlay/view"),
        tasks_create            : () => import('modals/tasks_create/view'),
        desktop_kpi             : () => import('modals/desktop_kpi/view'),
        contact_quick_deal      : () => import('modals/contact_quick_deal/view'),
        cost_click_edit         : () => import('modals/cost_click_edit/view'),
        link_gen                : () => import('modals/link_gen/view'),
        utm_create              : () => import('modals/utm_create/view'),
        campaign_edit           : () => import('modals/campaign_edit/view'),
        add_phone_contact       : () => import('modals/add_phone_contact/view'),
        edit_project            : () => import('modals/edit_project/view'),
        copy_project            : () => import('modals/copy_project/index'),
        total_costs             : () => import('modals/total_costs/view'),
        project_stats           : () => import('modals/project_stats/view'),
        redirect_to_contact     : () => import('modals/redirect_to_contact/view'),
        new_user_login          : () => import('modals/new_user_login/view'),
        callback_dialog         : () => import('modals/callback_dialog/view'),
        callback_rule           : () => import('modals/callback_rule/view'),
        callback_slide          : () => import('modals/callback_slide/view'),
        thanksSlide             : () => import('modals/thanksSlide/view'),
        callback_texts          : () => import('modals/callback_texts/view'),
        funnel_date_change      : () => import('modals/funnel_date_change/view'),
        payment                 : () => import('modals/payment/view'),
        blocked_lead            : () => import('modals/blocked_lead/view'),
        js_error                : () => import('modals/js_error/view'),
        change_tariff           : () => import('modals/change_tariff/view'),
        tariffs                 : () => import('modals/tariffs/view'),
        balance_callback        : () => import('modals/balance_callback/view'),
        simcard_order           : () => import('modals/simcard_order/view'),
        welcome_modal           : () => import('modals/welcome_modal/view'),
        confirm_modal           : () => import('modals/confirm_modal/view'),
        edit_site               : () => import('modals/edit_site/view'),
        vk_info_window          : () => import('modals/vk_info_window/view'),
        pages_list              : () => import('modals/pages_list/view'),
        content_dialog          : () => import('modals/content_dialog/view'),
        no_projects             : () => import('modals/no_projects/view'),
        email_edit              : () => import('modals/email_edit/view'),
        edit_domain             : () => import('modals/edit_domain/view'),
        dkim_domain             : () => import('modals/dkim_domain/view'),
        export_money            : () => import('modals/export_money/view'),
        source_edit             : () => import('modals/source_edit/view'),
        // page_info               : () => import('modals/page_info/view'),
        calendar                : () => import('modals/calendar/view'),
        leadsSegmentSearch      : () => import('modals/leadsSegmentSearch/index'),
        leadsSegmentSearchResult: () => import('modals/leadsSegmentSearchResult/index'),
        leadsSegmentSearchInfo  : () => import('modals/leadsSegmentSearchInfo/index'),
        lead_buy_info           : () => import('modals/lead_buy_info/view'),
        lead_buy_settings       : () => import('modals/lead_buy_settings/view'),
        defect_lead_confirm     : () => import('modals/defect_lead_confirm/view'),
        lead_sale_info          : () => import('modals/lead_sale_info/view'),
        lead_sale_settings      : () => import('modals/lead_sale_settings/view'),
        leadsAddField           : () => import('modals/leadsAddField/index'),
        leadsBuyModeration      : () => import('modals/leadsBuyModeration/index'),
        leadsWaitModeration     : () => import('modals/leadsWaitModeration/index'),
        tariffActivated         : () => import('modals/tariffActivated/index'),
        partnerNews             : () => import('modals/partnerNews/index'),
        renewal                 : () => import('modals/renewal/index'),
        renewalAprove           : () => import('modals/renewalAprove/index'),
        renewalApproveVoicebot  : () => import('modals/renewalApproveVoicebot/index'),
        simple                  : () => import('modals/simple/view'),
        tel_add_number          : () => import('modals/tel_add_number/view'),
        mtt_notify              : () => import('modals/mtt_notify/view'),
        confirmPhone            : () => import('modals/confirmPhone/index'),
        codeConfirmPhone        : () => import('modals/codeConfirmPhone/index'),
        smsSenderInstruction    : () => import('modals/smsSenderInstruction/index'),
        smsSenderEdit           : () => import('modals/smsSenderEdit/index'),
        leadsExport             : () => import('modals/leadsExport/index'),
        leadCategoryValueSelect : () => import('modals/leadCategoryValueSelect/index'),
        testTariff              : () => import('modals/testTariff/index'),
        fieldSettings           : () => import('modals/fieldSettings/index'),
        requiredFieldStageSelect: () => import('modals/requiredFieldStageSelect/index'),
        displayFieldStageSelect : () => import('modals/displayFieldStageSelect/index'),
        mobileVersion           : () => import('modals/mobileVersion/index'),
        selectTariff           : () => import('modals/selectTariff/index'),

        create: function (name, callback) {
            if (typeof this[name] === 'undefined') {
                throw new Error('Modal with name ' + name + ' not found');
            }

            this[name]()
              .then((modal) => {
                callback(modal.default)
              });
        }
    };
});
